import { fetcher } from 'services/helpers/responseHandler'

const histories = async ({ month, year }) => fetcher.get('pms/histories', { month, year })

const login = async ({ userName, password, propertyId, apiKey, pmsChainCode, phone }) =>
  fetcher.post('pms/login', {
    userName,
    password,
    apiKey,
    propertyId,
    pmsChainCode,
    phone
  })

const download = async ({ reportId }) => fetcher.get(`pms/histories/${reportId}/download`)

const syncStatus = async () => fetcher.get('pms/sync-status')

const healthCheck = async ({ subsidiaryIds }) =>
  fetcher.get('pms/healthcheck', { subsidiaryIds })

const getRoomKeyHotels = async ({ apiKey }) =>
  fetcher.get('pms/roomkey/hotels', { apiKey })

const pmsToggle = async ({ SubsidiaryId, Pms, Status }) =>
  fetcher.post('pms/sync/toggle', { SubsidiaryId, Pms, Status })

const pmsApi = {
  histories,
  download,
  login,
  syncStatus,
  getRoomKeyHotels,
  healthCheck,
  pmsToggle
}

export default pmsApi
